// src/hooks/useTranslation.js
import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { et } from "./ET";
import { ru } from "./RU";

const translations = {
  ru,
  et,
};

const supportedLanguages = ["et", "ru"];
const defaultLanguage = "et";


const getBasePath = () => {
  // Check if we're in a subdirectory deployment
  const homepage = process.env.PUBLIC_URL || '';
  
  if (homepage && homepage !== '') {
    try {
      const url = new URL(homepage);
      return url.pathname;
    } catch {
      // If it's not a full URL, treat it as a path
      return homepage.startsWith('/') ? homepage : `/${homepage}`;
    }
  }
  
  return '';
};

const basePath = getBasePath();
const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  const [language, setLanguage] = useState(defaultLanguage);
  const [translationsEnabled, setTranslationsEnabled] = useState(true);

  // Update HTML lang attribute for screen readers
  useEffect(() => {
    document.documentElement.setAttribute("lang", language);
  }, [language]);

  // Set language from URL parameter
  const setLanguageFromURL = useCallback((lang) => {
    if (supportedLanguages.includes(lang)) {
      setLanguage(lang);
    } else {
      setLanguage(defaultLanguage);
    }
  }, []);

  // Get localized path for links - this doesn't require navigation
  const getLocalizedPath = useCallback(
    (path, currentLang = language) => {
      // Remove any existing language prefix
      const cleanPath = path.replace(/^\/(et|ru)(\/|$)/, "/");

      return `/${currentLang}${cleanPath === "/" ? "" : cleanPath}`;
    },
    [language]
  );

  const t = (key) => {
    /*    if (
      !translationsEnabled ||
      !translations[language] ||
      !translations[language][key]
    ) {
      return key;
    }*/
    return translations[language][key];
  };

  const toggleTranslations = () => {
    setTranslationsEnabled((prev) => !prev);
  };

  const value = {
    t,
    language,
    translationsEnabled,
    setLanguageFromURL,
    toggleTranslations,
    supportedLanguages,
    getLocalizedPath,
    basePath
  };

  return <TranslationContext value={value}>{children}</TranslationContext>;
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error("useTranslation must be used within TranslationProvider");
  }
  return context;
};
